module.exports = __webpack_public_path__ + "static/media/Arrow-Right.861f8256.svg";